
















import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject, ActiveProvide} from "@/support/reactive"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"

/**
 * @status stable
 * @published 4.5.0
 * @changelog 4.5.0 Published.
 * @changelog 4.6.0 Add min-height.
 */
@Component({
    components: {JdhHeightTransition}
})
export default class JdsWorkbenchToolbar extends Vue {
}
